import {AbstractTransform, TransformInteractionState} from "../abstract-transform";
import {SnapPoint} from "../../snap";
import {DrawPolygon} from "@mapbox/mapbox-gl-draw";
import {Feature} from "geojson";

export class EditorVertexDelete extends AbstractTransform<TransformInteractionState> {
  public getVertexIcon(): string {
    return "map-trash";
  }

  public transform(state: any, e: mapboxgl.MapMouseEvent, snapPoint: SnapPoint) {
  }

  async onClick(state: any, e: mapboxgl.MapMouseEvent): Promise<void> {
    let marker = this._isMarker(e, 'map-trash');
    if (marker === undefined) {
      return;
    }
    e.preventDefault();
    this.controller.interaction.historyPush(state);
    (this.transformedFeature as DrawPolygon).removeCoordinate(marker.properties.coord_path);
    this.displayDrawFeature(this.transformedFeature);

    this.vertexMarkers.forEach(marker => this.removeDrawFeature(marker.id.toString()))
    this.vertexMarkers = this._generateVertexMarkers(this.transformedFeature.toGeoJSON() as Feature, this.getVertexIcon());

    state.features.get(state.featureID).geometry = (this.transformedFeature.toGeoJSON() as Feature).geometry;

    this.tick();
  }
}
